import { Navigate, useLocation } from "react-router-dom";
import { useForAuthorisation } from "./context";

export default function PrivateRoutes({ children }) {
  //MAKE SURE TO {DESTRUCTURE } LOGGEDINUSER!!!
  //loading comes from context file as props with the context hook. used because auth changed is asynchrounous, so in delay
  // after page refresh loggedinuser is signed out, therefore is loading allows user to stay signed in. we can also add a
  // component to render while page is loading so unauthenticated users dont get access as well to ui?
  //

  const { loading, loggedInUser } = useForAuthorisation();

  // console.log(loggedInUser);
  const location = useLocation();

  if (loading) {
    return (
      <div className="spinner-border m-5 text-primary" role="status"></div>
    );
  }

  if (!loggedInUser) {
    // Pass the current location in state so Login can redirect back
    return <Navigate to="/Login" state={{ from: location }} replace />;
  }

  return children;
}
